// import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonContent, IonRouterLink } from "@ionic/react";
import React, { Component } from "react";
import zach from "../images/zach.jpg";
import logo from "../images/logoDark.png";
import logoTop from "../images/logoTop.png";

class Home extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  openingParagraph = (
    <span>
      Welcome! My name is Zach and I'm an experienced technology and media literacy teacher.  I taught for twelve years at a <a href="https://www.corlearsschool.org">private school</a> in
      Chelsea, and more recently began work at a <a href="https://www.ps40.org/">public  school</a> in Gramercy.  I've also taught coding to adults and teenagers at various <a href="https://www.quickstart.com/">bootcamps</a>. I offer tutoring in 
      technology-related subjects to people of all ages. I work one-on-one or
      with small groups, and my services are available in New York City or
      remotely via Zoom.
    </span>
  );

  credentials = (
    <div>
      <li>
        Master's degree from Columbia University in K-12 Technology Education
      </li>
      <li>Bachelor's degree from Connecticut College in English</li>
      <li>NYS Certificate: Educational Technology (Grades K-12)</li>
      <li>NYS Certificate: Computer Technology (Grades 7-12)</li>
      <li>NYS Certificate: Childhood Education (Grades 1-6)</li>
      <li>
        Creator of{" "}
        <a href="https://www.medialab.org/">MediaLab.org</a>
      </li>

      <li>
        Author of{" "}
        <a href="https://www.mathartprojects.com">
          Math Art: Hands-On Math Activities for Grades of 2-4
        </a>
        
      </li>
      <li>
        Founder of the{" "}
        <a href="https://www.thepaperoption.org">ThePaperOption.org</a>
      </li>
      <li>
        Over twelve years of teaching experience (elementary school, high
        school, & adults)
      </li>
    </div>
  );
  teenAdults = (
    <div>
      <li>
        <IonRouterLink href="/claude-code">Claude Code</IonRouterLink>
      </li>
      <li>
        Coding websites &{" "}
        <IonRouterLink href="/javascript">web apps</IonRouterLink> using
        JavaScript
      </li>
      <li>
        Coding interactive art using p5.js (JavaScript) Library
      </li>
      <li>
        AP Computer Science test prep using Java
      </li>
      <li>
        Coding <IonRouterLink href="/javascript">iOS</IonRouterLink> &{" "}
        <IonRouterLink href="/javascript">Android apps</IonRouterLink> using
        JavaScript
      </li>
      
      <li>
        Coding with{" "}
        <IonRouterLink href="/javascript">React + Ionic</IonRouterLink>
      </li>
      <li>
        <IonRouterLink href="/photography">Photography</IonRouterLink> & photo
        editing
      </li>
      <li>
        <IonRouterLink href="/editing">Video editing</IonRouterLink> and audio
        editing
      </li>
      <li>Game design (Unity)</li>
      <li>Arduino, Micro:Bit, & Raspberry Pi</li>
      <li>Operating system fundamentals (Windows, Mac, Chromebook, & mobile)</li>
      <li>All other hardware and software troubleshooting</li>
    </div>
  );

  kids = (
    <div>
      <li>
        Coding with <IonRouterLink href="/scratch">Scratch</IonRouterLink> (ages
        7-14)
      </li>
      <li>
        Coding with <IonRouterLink href="/scratchjr">Scratch Jr</IonRouterLink>.
        (ages 5-7)
      </li>
      <li>
        <IonRouterLink href="/lego">Lego robotics</IonRouterLink>
      </li>
      <li>
        <IonRouterLink href="/animation">Animation</IonRouterLink>
      </li>
      <li>
        <IonRouterLink href="/3d-design">3D design</IonRouterLink>
      </li>
      <li>
        <IonRouterLink href="/movies">Movie making</IonRouterLink> and video
        editing
      </li>
      <li>
        Stop motion and{" "}
        <IonRouterLink href="/claymation">claymation</IonRouterLink>
      </li>
      <li>Digital drawing</li>
      <li>Minecraft</li>
    </div>
  );

  // applications = (
  //   <div>
  //     <li>iMovie</li>
  //     <li>Garage Band</li>
  //     <li>Adobe Photoshop</li>
  //     <li>Adobe Illustrator</li>
  //     <li>Adobe Premier Pro</li>
  //     <li>Adobe Creative Suite</li>
  //     <li>MS Office</li>
  //     <li>Most other Windows, Apple, & Google applications</li>
  //   </div>
  // );

  prices = (
    <div>
      <li>
        <span style={{ display: "inline-block", width: "144px" }}>
          One-on-one:
        </span>
        <strong>$120/hour</strong>
      </li>
      <li>
        <span style={{ display: "inline-block", width: "144px" }}>
          Class of two:
        </span>
        <strong>$90/hour </strong>
      </li>
      <li>
        <span style={{ display: "inline-block", width: "144px" }}>
          Class of three:
        </span>
        <strong>$75/hour </strong>
      </li>
      <li>
        <span style={{ display: "inline-block", width: "144px" }}>
          Class of four:
        </span>
        <strong>$60/hour </strong>
      </li>
      <br />
      <span style={{ fontStyle: "italic" }}>Flexible rates: higher for specialized or accelerated work, lower for off-peak hours or for families with financial need.</span>
    </div>
  );

  contact = (
    <div>
      To learn more about my tutoring services, or to schedule a lesson, please
      send an email to{" "}
      <a href="mailto:zach@codingtutor.nyc">zach@codingtutor.nyc</a>.
      <br />
      <br />
      I look forward to hearing from you! <br />
    </div>
  );

  render() {
    let header: any;
    let main: any;

    ///////////////// MOBILE RENDER /////////////////
    if (this.props.appState.size == "mobile") {
      header = (
        <header className="cell headerMobile">
          <div style={{ fontSize: "29pt" }}>Zachary J. Brewer</div>
          <h1 style={{ fontSize: "18pt", paddingTop: "5px" }}>
            NYC Coding & Tech Tutor
          </h1>
        </header>
      );

      main = (
        <main className="cell mainMobile">
          <img src={zach} className="headshotMobile" />
          {this.openingParagraph}

          <div className="subHeadingMobile">Credentials</div>
          <ul style={{ marginTop: "8px", paddingLeft: "30px" }}>
            {this.credentials}
          </ul>

          <div className="subHeadingMobile">Subjects for Kids</div>
          <ul style={{ marginTop: "8px", paddingLeft: "30px" }}>{this.kids}</ul>

          <div className="subHeadingMobile">Subjects for Adults & Teens</div>
          <ul style={{ marginTop: "8px", paddingLeft: "30px" }}>
            {this.teenAdults}
          </ul>

          {/* <div className="subHeadingMobile">Applications</div>
          <ul style={{ marginTop: "8px", paddingLeft: "30px" }}>
            {this.applications}
          </ul> */}

          <div className="subHeadingMobile">Prices</div>
          <ul
            style={{
              marginTop: "8px",
              paddingLeft: "30px",
              paddingRight: "0px",
              marginBottom: "0px",
            }}
          >
            {this.prices}
          </ul>
          <div className="subHeadingMobile">Contact</div>
          {this.contact}

          <div
            style={{
              textAlign: "center",
              marginTop: "28px",
              marginBottom: "14px",
            }}
          >
            <a href="/" style={{ textDecoration: "none" }}>
              <img style={{ width: "110px" }} src={logo} />
              <br />
              <span style={{ fontSize: "12pt", letterSpacing: "1.4px" }}>
                &copy; CodingTutor.nyc
              </span>
            </a>
          </div>
        </main>
      );
    }

    ///////////////// DESKTOP RENDER /////////////////
    if (this.props.appState.size == "desktop") {
      header = (
        <header className="cell headerDesktop">
          <div style={{ fontSize: "50pt" }}>Zachary J. Brewer</div>
          {/* <img className="logoTop" src={logoTop} /><br/> */}
          <h1 className="homeHeading" style={{ fontSize: "30pt" }}>
            NYC Coding & Tech Tutor
          </h1>
        </header>
      );

      main = (
        <main className="cell mainDesktop">
          <img src={zach} className="headshotDesktop" />
          {this.openingParagraph}

          <div className="subHeadingDesktop">Credentials</div>
          <ul style={{ marginTop: "8px", paddingLeft: "44px" }}>
            {this.credentials}
          </ul>

          <div className="subHeadingDesktop">Subjects for Kids</div>
          <ul style={{ marginTop: "8px", paddingLeft: "44px" }}>{this.kids}</ul>

          <div className="subHeadingDesktop">Subjects for Adults & Teens</div>
          <ul style={{ marginTop: "8px", paddingLeft: "44px" }}>
            {this.teenAdults}
          </ul>

          {/* <div className="subHeadingDesktop">Applications</div>
          <ul style={{ marginTop: "8px", paddingLeft: "44px" }}>
            {this.applications}
          </ul> */}

          <div className="subHeadingDesktop">Prices</div>
          <ul
            style={{
              marginTop: "8px",
              paddingRight: "0px",
              paddingLeft: "44px",
              marginBottom: "0px",
            }}
          >
            {this.prices}
          </ul>
          <div className="subHeadingDesktop">Contact</div>
          {this.contact}

          <div
            style={{
              textAlign: "center",
              marginTop: "28px",
              marginBottom: "14px",
            }}
          >
            <a href="/" style={{ textDecoration: "none" }}>
              <img style={{ width: "120px" }} src={logo} />
              <br />
              <span style={{ fontSize: "12pt", letterSpacing: "1.4px" }}>
                &copy; CodingTutor.nyc
              </span>
            </a>
          </div>
        </main>
      );
    }

    return (
      <IonContent color="secondary">
        <section>
          {header}
          {main}
        </section>
      </IonContent>
    );
  }
}

export default Home;
